import React from 'react'
import { BorderStyle, PaddingType } from './types/stylesTypes'

type HorizontalLineProps = {
  color: string
  borderWidth?: number
  style?: BorderStyle
  padding: PaddingType
}

function HorizontalLine({ color, borderWidth, style, padding }: HorizontalLineProps) {
  return (
    <table
      role="presentation"
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      style={{ width: '100%' }}
    >
      <tbody>
        <tr>
          <td
            style={{
              paddingTop: padding.paddingTop,
              paddingRight: padding.paddingRight,
              paddingBottom: padding.paddingBottom,
              paddingLeft: padding.paddingLeft,
            }}
          >
            <p
              style={{
                borderColor: color,
                borderTopWidth: borderWidth,
                borderTopStyle: style,
                margin: 0, // reset browser default value
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default HorizontalLine
